<template>
  <v-card
    style="display: inline-block; width: 257px"
    class="elevation-0 rounded-lg base-help-text"
  >
    <v-card-text class="card-title pb-0">
      <div class="text-left base-help-text" style="font-size: 15px">
        {{ helpTitle }}
      </div>
    </v-card-text>
    <v-card-text class="pt-2 card-title">
      <div class="text-left base-help-text" style="font-size: 13px">
        {{ helpContent }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";

@Component
export default class BaseHelp extends Vue {
  @Prop({ default: null }) helpTitle!: string;

  @Prop({ default: null }) helpContent!: string;
}
</script>

<style lang="scss" scoped>
.base-help-text {
  background-color: #d9ecff;
  color: $primary_color !important;
  font-weight: 500;
  line-height: 1.1;
}

.base-help-text:after {
  content: "";
  position: absolute;
  left: 0;
  top: 25%;
  width: 0;
  height: 0;
  border: 9px solid transparent;
  border-right-color: #d9ecff;
  border-left: 0;
  margin-top: -9px;
  margin-left: -9px;
}
</style>
